module.exports = __webpack_public_path__ + "img/picture_href.02010b44.jpg";